import { USER_TYPE } from "constants/user-type";
import routes from "constants/routes";

export type RoutePermission = {
  [path: string]: (keyof typeof USER_TYPE)[];
};

export const ROUTE_PERMISSION: RoutePermission = {
  // 見積一覧（店舗）：C0001、C0002、C0003、C0006
  "/quote-list": ["C0001", "C0002", "C0003", "C0006"],
  // ====
  // 新規見積（店舗、得意先）：C0002、C0003
  "/new-quote": ["C0002", "C0003"],
  // ====
  // 工賃設定（店舗）：C0001、C0002、C0006
  "/mst-proc-fee/setting": ["C0001", "C0002", "C0006"],
  // ====
  // タイヤ売価設定（本部）：C0001 ※画面自体は店舗と同一
  // タイヤ特価設定（店舗）：C0002  ※画面自体は本部と同一
  "/mst-proc-fee": ["C0002", "C0003"],
  // ====
  // タイヤ売価設定（店舗）※ブランド詳細：C0002  ※画面自体は本部と同一
  // タイヤ特価設定（店舗）：C0002  ※画面自体は本部と同一
  // タイヤ特価設定（本部）：C0001 ※画面自体は店舗と同一
  // ====
  // マスタ管理店舗一覧（本部）：C0001
  // マスタ管理店舗詳細（本部）：C0001
  "/mst-store": ["C0001"],
  // ====
  // マスタ管理利用者一覧（本部）：C0001
  // マスタ管理利用者詳細（登録/変更）：C0001
  "/mst-user": ["C0001"],
  // ====
  // マスタ管理商品一覧（本部）：C0001
  // マスタ管理商品詳細（本部）：C0001
  "/mst-item": ["C0001"],
  // ====
  // マスタ管理商品詳細価格（本部）：C0001
  "/mst-item/:id/edit-price": ["C0001"],
  // ====
  // マスタ管理商品タイヤ一覧（本部）：C0001
  // マスタ管理商品タイヤ詳細（本部）：C0001
  // ====
  // マスタ管理ブランド詳細タイヤ（本部）：C0001
  "/mst-store/tire-brand": ["C0001", "C0002"],
  // ====
  // マスタ管理得意先一覧（本部）：C0001
  // マスタ管理得意先詳細（本部）：C0001
  "/mst-client": ["C0001"],
  // ====
  // マスタ管理得意先発送先登録変更（本部）：C0001
  "/mst-client/:id/mst-shipping-dest": ["C0001"],
  // ====
  // マスタ管理企業一覧（本部）：C0001
  "/mst-yh-company": ["C0001"],
  // ====
  // マスタ管理仕入先一覧（本部）：C0001
  // マスタ管理仕入先一覧詳細（本部）：C0001
  [routes.mstVendor]: ["C0001"],
  // ====
  // マスタ管理分類マスタ：C0001
  [routes.mstCategory]: ["C0001"],
  // ====
  // マスタ管理CSVアップロードタイヤ詳細：C0001
  // マスタ管理CSVアップロードタイヤ特価：C0001
  // マスタ管理CSVアップロードキャッシュバック：C0001
  "/mst-csv": ["C0001"],
  "/mst-store/tire-list": ["C0001"],
  // 在庫: C0002,C0003,C0004
  "/stock/client": ["C0003"],
  "/stock/company": ["C0006"],
  "/stock/supplier": ["C0004", "C0007", "C0008"],
  "/stock/store": ["C0002"],
  "/stock/main": ["C0001"],
  "/stock/main/update": ["C0001"],
  "/orders": ["C0001"],
  "/order/form": ["C0001"],
  "/orders/store": ["C0002", "C0003", "C0006"],
  "/order/store/form": ["C0002", "C0003", "C0006"],
  "/orders/supplier": ["C0004", "C0007", "C0008"],
  "/orders/weekly-replenishment": ["C0001"],
  "/order/rpa": ["C0001"],
  "/mst-4bundle-price-twset/setting": ["C0002", "C0006"],
  [routes.mst4BundlePriceTwSetSetting]: ["C0002", "C0006"],
  "/mst-wheel-price/setting": ["C0001", "C0002", "C0006"],
  "/mst-car-model/result": ["C0002", "C0003"],
  "/mst-car-tiresize/search": ["C0002", "C0003"],
  "/mst-car-model/selection": ["C0002", "C0003"],
  "/mst-car-model/product-code": ["C0002", "C0003"],
  "/tire-report": ["C0001","C0002","C0003","C0004","C0005","C0006","C0007","C0008","C0009"], // ["C0001","C0002","C0003","C0006"],
  "/system-usage": ["C0001","C0002","C0003","C0004","C0005","C0006","C0007","C0008","C0009"], // ["C0001","C0002","C0003","C0006"],
  "/sms-report": ["C0001","C0002","C0003","C0004","C0005","C0006","C0007","C0008","C0009"], // ["C0001"],
  "/bo-error-report": ["C0001","C0002","C0003","C0004","C0005","C0006","C0007","C0008","C0009"], // ["C0001"],
  "/supplier-warehouse": ["C0004"],
  "/mst-maintenance": ["C0001"],
  [routes.mstTireWheelStore]: ["C0002", "C0003"],
  [routes.mstConfirmProcFee]: ["C0002", "C0003"],
  [routes.mstWheel]: ["C0001"],
};
